export const CycleStatus = {
  New: 'New',
  Open: 'Open',
  Closed: 'Closed',
}
